import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import { ListItemIcon, ListItemText, MenuItem, Typography } from '@mui';

const Icon = withStyles(ListItemIcon, {
  root: {
    minWidth: 'auto',
    paddingRight: '1rem'
  }
});

const Text = withStyles(ListItemText, {
  root: {
    paddingRight: '2rem'
  }
});

const IconMenuItem = ({ children, icon, onClick, secondary }) => (
  <MenuItem onClick={onClick}>
    {icon && <Icon role="img">{icon}</Icon>}
    <Text>{children}</Text>
    {secondary && (
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {secondary}
      </Typography>
    )}
  </MenuItem>
);

IconMenuItem.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.object,
  onClick: PropTypes.func,
  secondary: PropTypes.string
};

export default IconMenuItem;
